/* eslint-disable import/prefer-default-export */
import React from 'react';

export const CommonContainer = React.forwardRef((props: any, ref) => {
    const renderProps = { ...props };
    delete renderProps.type;
    switch (props.type) {
        case 'svg':
            return <svg ref={ref} {...renderProps}>
                {props.children}
            </svg>;
        case 'g':
            return <g ref={ref} {...renderProps}>
                {props.children}
            </g>;
        default:
            return <div ref={ref} {...renderProps}>
                {props.children}
            </div>;
    }
});

CommonContainer.displayName = 'DomContainer';


